import { render, staticRenderFns } from "./EmailLanguageSelect.vue?vue&type=template&id=6975c21d&scoped=true&"
import script from "./EmailLanguageSelect.vue?vue&type=script&lang=js&"
export * from "./EmailLanguageSelect.vue?vue&type=script&lang=js&"
import style0 from "./EmailLanguageSelect.vue?vue&type=style&index=0&id=6975c21d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6975c21d",
  null
  
)

export default component.exports